// semeia-disable-reexport
import type Patient from "parog-web/models/patient";
import type { BufferedChangeset } from "ember-changeset/types";

export async function validateAndSaveChangeset(
  changeset: BufferedChangeset
): Promise<Patient> {
  const missingMandatoryFields: string[] = [];

  if (!changeset.birthday) {
    missingMandatoryFields.push("date de naissance");
  }

  if (!changeset.gender) {
    missingMandatoryFields.push("sexe");
  }

  if (!changeset.birthName && !changeset.lastName) {
    missingMandatoryFields.push("nom de naissance");
  }

  if (!changeset.birthFirstName && !changeset.firstName) {
    missingMandatoryFields.push("prénom(s) de naissance");
  }

  if (missingMandatoryFields.length > 0) {
    throw new Error(
      `Il manque les informations suivantes dans la fiche patient : ${missingMandatoryFields.join(
        ", "
      )}.`
    );
  }

  try {
    await changeset.validate();
  } catch {
    throw new Error(
      "Veuillez corriger les erreurs avant de tenter une récupération de l'INS"
    );
  }

  if (changeset.get("isInvalid")) {
    throw new Error(
      "Veuillez corriger les erreurs avant de tenter une récupération de l'INS"
    );
  }

  return await changeset.save();
}
